<template>
  <div class="home">
    <dv-full-screen-container>
      <Map
        :theme="theme"
        @alarmsInfo="alarmsInfo"
      />
      <div class="title">
        <h6>桥梁数据监控平台</h6>
        <div>
          <dv-decoration-8 />
          <dv-decoration-8 :reverse="true" />
        </div>
        <!-- <dv-decoration-5 /> -->
      </div>
      <div class="msg">
        <a-row class="color1">
          <a-col>预警信息</a-col>
          <a-col>
            <a-select
              class="a-select"
              v-model:value="time"
              placeholder="请选择"
              @change="timeRangeChange"
            >
              <a-select-option
                :value="item.value"
                v-for="(item, i) in timeRange"
              >{{item.date}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row
          justify="space-between"
          class="a-row1"
        >
          <a-col>
            <dv-border-box-13>
              <p>预警数量</p>
              <span class="">{{alarmQuantity.alarmQuantity}}条</span>
            </dv-border-box-13>
          </a-col>
          <a-col>
            <dv-border-box-13>
              <p>一级预警</p>
              <span class="">{{alarmQuantity.oneLevelAlarmQuantity}}条</span>
            </dv-border-box-13>
          </a-col>
          <a-col>
            <dv-border-box-13>
              <p>二级预警</p>
              <span class="">{{alarmQuantity.twoLevelAlarmQuantity}}条</span>
            </dv-border-box-13>
          </a-col>
          <a-col>
            <dv-border-box-13>
              <p>三级预警</p>
              <span class="">{{alarmQuantity.threeLevelAlarmQuantity}}条</span>
            </dv-border-box-13>
          </a-col>
        </a-row>
        <a-row
          justify="space-between"
          class="a-row2"
        >
          <a-col>
            <dv-decoration-9 style="color: #00FFF0">{{monitorQuantity.lineQuantity}}</dv-decoration-9>
            <span>线路数量</span>
          </a-col>
          <a-col>
            <dv-decoration-9 style="color: #FF0000">{{monitorQuantity.bridgeQuantity}}</dv-decoration-9>
            <span>桥梁数量</span>
          </a-col>
          <a-col>
            <dv-decoration-9 style="color: #28CC3C">{{monitorQuantity.productQuantity}}</dv-decoration-9>
            <span>产品数量</span>
          </a-col>
          <a-col>
            <dv-decoration-9 style="color: #FA8724">{{monitorQuantity.deviceQuantity}}</dv-decoration-9>
            <span>设备数量</span>
          </a-col>
        </a-row>
      </div>
      <!-- <a-row class="color1">
        <a-col>实时预警</a-col>
      </a-row> -->
      <dv-scroll-board
        class="table"
        v-model:config="config"
        @mouseover="tableMouseover($event)"
      />
      <div
        class="detail"
        v-if="detail"
        :style="{left: left, top: top}"
      >{{detail}}</div>
    </dv-full-screen-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header/header.vue";
import Map from "@/components/home/map.vue";
import { getAlarmQuantity, getDeviceStatus, getIotAlarmList, getMonitorQuantity } from "@/api/datas/datas.js";

export default {
  components: {
    Header,
    Map,
  },
  data() {
    return {
      theme: 'dark',
      query: {},
      alarmQuantity: {},
      timeRange: [
        {
          value: 1,
          date: '当日'
        },
        {
          value: 2,
          date: '7天内'
        },
        {
          value: 3,
          date: '一个月'
        },
        {
          value: 4,
          date: '全部'
        },
      ],
      time: 3,
      lineId: 0,
      deviceStatus: {},
      alarmList: {},
      monitorQuantity: {},
      config: {},
      detail: '',
      left: 0,
      top: 0
    }
  },
  mounted() {
    this.init()
    getDeviceStatus(this.query).then(res => { //获取设备状态统计
      if (res.code == 200) {
        this.deviceStatus = res.data
      }
    })
    getMonitorQuantity(this.query).then(res => { //获取监控数量
      if (res.code == 200) {
        this.monitorQuantity = res.data
      }
    })
    getIotAlarmList(this.query).then(res => { //获取预警消息列表
      if (res.code == 200) {
        let arr = []
        for (let i = 0; i < res.data.list.length; i++) {
          const element = res.data.list[i];
          arr[i] = []
          arr[i][0] = element.bridgeName
          arr[i][1] = element.alarmName
          arr[i][2] = element.level
          arr[i][3] = element.createTime
        }
        this.config = {
          header: ['桥梁名称', '警报名称', '预警等级', '时间'],
          data: [
            ...arr
          ],
          align: 'center'
        }
        console.log(this.config)
      }
    })
  },
  methods: {
    init() {
      getAlarmQuantity({ date: this.time }).then(res => { //获取预警数量
        if (res.code == 200) {
          this.alarmQuantity = res.data
        }
      })
    },
    alarmsInfo(e) {
      // console.log(e)
      if (e) {
        this.lineId = Number(e)
      }
      getAlarmQuantity({ date: this.time, lineId: this.lineId }).then(res => { //获取预警数量
        if (res.code == 200) {
          this.alarmQuantity = res.data
        }
      })
    },
    tableMouseover(e) {
      console.log(e)
      if (e.x) {
        this.left = e.x + 'px'
        this.top = e.y + 'px'
      }
      if (e.columnIndex == 1 || e.columnIndex == 3) {
        console.log(e.ceil)
        this.detail = e.ceil
      } else {
        this.detail = ''
      }
    },
    timeRangeChange(value) {
      console.log(value)
      for (let i = 0; i < this.timeRange.length; i++) {
        const el = this.timeRange[i];
        if (el.value == value) {
          this.time = el.value
          if (this.lineId) {
            this.alarmsInfo()
          } else {
            this.init()
          }
        }
      }
    }
  }
};
</script>
<style scoped>
.home :deep() .map {
  height: 100%;
}
.home :deep() #container {
  height: 100%;
  margin: 0;
}
.title {
  position: fixed;
  left: 25%;
  top: 36px;
  width: 50%;
  text-align: center;
}
.title h6 {
  margin: 0;
  font-weight: bold;
  line-height: 1;
  font-size: 38px;
  color: #6abfdb;
}
.title > div {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dv-decoration-8 {
  width: 300px;
  height: 40px;
}
.dv-decoration-5 {
  width: 600px;
  height: 40px;
  margin: 0 auto;
}
.msg {
  position: absolute;
  top: 100px;
  left: 100px;
  width: 500px;
}
.msg .ant-row {
  padding: 10px 0;
}
.a-select {
  width: 160px;
  margin-left: 24px;
  color: #fff;
}
.a-select :deep() .ant-select-selector {
  background: rgb(0, 186, 255);
  border: 0;
}
.a-select :deep() .ant-select-selection-placeholder {
  color: #fff;
}
.color1 {
  font-size: 18px;
  color: #fff;
}
.a-row1 .ant-col {
  width: 85px;
  height: 104px;
  line-height: 1;
  /* background: url(~@/assets/images/dp.png) no-repeat center;
  background-size: 100% 100%; */
}
.dv-border-box-13 :deep() .border-box-content {
  padding-top: 15px;
}
.a-row1 .ant-col p {
  line-height: 3;
  font-size: 14px;
  color: #fff;
}
.a-row1 .ant-col span {
  font-size: 20px;
  color: #fff;
}
.a-row2 .ant-col p {
  width: 84px;
  height: 84px;
  line-height: 80px;
  box-sizing: border-box;
  border-radius: 50%;
  background: url(~@/assets/images/dp-quan.png) no-repeat center;
  background-size: 100% 100%;
}
.dv-decoration-9 {
  width: 100px;
  height: 100px;
  font-size: 20px;
}
.a-row2 .ant-col > span {
  font-size: 14px;
  color: #fff;
}
.table {
  position: absolute;
  top: 430px;
  left: 100px;
  width: 500px;
  height: 260px;
}
.detail {
  position: fixed;
  width: auto;
  padding: 12px;
  font-size: 14px;
  color: #fff;
  background: rgb(10, 39, 50);
}
.home :deep() .diagram {
  background: rgb(255, 255, 255, 0.1);
}
.home :deep() .diagram span {
  color: #666;
}
.home :deep() .tree {
  background: rgb(10, 39, 50, 0.8);
}
.home :deep() .ant-tree.ant-tree-show-line li span.ant-tree-switcher {
  color: #0088ff;
  background: none;
}
.home :deep() .ant-tree.ant-tree-show-line li:not(:last-child)::before {
  border-left: 1px solid #0088ff;
}
.home :deep() .tree .ant-tree li .ant-tree-node-content-wrapper {
  padding: 0 12px;
  color: #fff;
  border-radius: 6px;
  background: rgb(7, 83, 112, 0.5);
}
.home :deep() .tree .ant-tree li .ant-tree-node-content-wrapper:hover {
  background: none;
}
</style>
